<template>
<s-modal
            :open="open"
            :close="true"
            :title="labelEquipe(equipe)"
            :deleteData="true"
            @close="$emit('close')"
            @delete="$emit('supprimerScore')"
        >
           
            <div >
                
                <s-switch id="scoreMax" 
                    label-enable-text="Le score du gagnant se met automatiquement"
                    label-disable-text="Le score du gagnant ne se met pas automatiquement"
                    :defaultState="scoreMax"
                    @change="scoreMax=!scoreMax"
                /><br/>
                <div v-if="equipe!=null && type!=null && scoreMax">
                L'equipe 
                    <span :class="'titleScore'+type" v-if="equipe[type].J1!=null"> 
                        <span v-if="equipe[type].J1.numero==null">?</span>
                        <span v-else>{{parseInt(equipe[type].J1.numero)+1}} </span>
                    </span>
                    <span :class="'titleScore'+type" v-if="equipe[type].J2!=null"> {{equipe[type].J2.numero+1}} </span>
                    <span :class="'titleScore'+type" v-if="equipe[type].J3!=null"> {{equipe[type].J3.numero+1}} </span>
                a gagné ?
                &nbsp;&nbsp;<s-button label="OUI" theme="is-success" @onclick="equipeWin()"/></div>
                
                <div v-if="equipe!=null && type!=null ">
                ou l'equipe 
                    <span :class="'titleScore'+type" v-if="equipe[type].J1!=null"> 
                        <span v-if="equipe[type].J1.numero==null">?</span>
                        <span v-else>{{parseInt(equipe[type].J1.numero)+1}} </span> 
                    </span>
                    <span :class="'titleScore'+type" v-if="equipe[type].J2!=null"> {{equipe[type].J2.numero+1}} </span>
                    <span :class="'titleScore'+type" v-if="equipe[type].J3!=null"> {{equipe[type].J3.numero+1}} </span>
                <b v-if="scoreMax"> a perdu et </b> a marqué :
                </div>
                <div v-for="score in tabScore" class="score">
                    <s-button v-if="equipe!=null" 
                        :label="score" :icon="equipe.score[type]==score ? 'check' : ''"
                        :theme="(type=='joueurs' ? 'is-info ' : 'is-danger ') + 'is-medium'" @onclick="saveScore(score)"
                        :id="'P'+score"
                        />
                </div>
                <div class="score" v-if="!scoreMax">
                    <s-button 
                        v-if="equipe!=null" 
                        :label="pointMax" icon=""
                        :theme="(type=='joueurs' ? 'is-info ' : 'is-danger ') + 'is-medium'" 
                        @onclick="saveScore(pointMax)"
                    />
                </div>
            </div>
        </s-modal>
</template>
<style scoped>
.titleScorejoueurs {
        border: thin solid blue;
        color: blue;
        display: inline-block;
        border-radius: 20px;
        margin: 10px;
        padding: 3px;
        font-weight: bolder;
        width: 30px;
        text-align: center;
    }
    .titleScorecontre {
        border: thin solid red;
        color: red;
        display: inline-block;
        border-radius: 20px;
        margin: 10px;
        padding: 3px;
        font-weight: bolder;
        width: 30px;
        text-align: center;
    }
    .score {
        display: inline-block;
        margin: 10px;
    }
</style>
<script>

export default ({
    props:["open", "equipe", "type","pointMax"],
    data() {
        return {
            scoreMax: true
        }
    },
    computed: {
         tabScore: {
            get() {
                var tab=[];
                for (var i=0;i<this.pointMax;i++)
                    tab.push(i+'');
                return tab;
            }
        },
    },
    methods: {
         labelEquipe(equipe) {
              if (equipe!=null) {
              var joueurs = "";
              if (equipe.joueurs.J1 != null) {
                if (equipe.joueurs.J1.numero == null)
                    joueurs += "?";
                else
                    joueurs += (equipe.joueurs.J1.numero+1);
              }
              if (equipe.joueurs.J2 != null)
                joueurs += " - " + (equipe.joueurs.J2.numero+1);
              if (equipe.joueurs.J3 != null)
                joueurs += " - " + (equipe.joueurs.J3.numero+1);
             var contre = "";
              if (equipe.contre.J1 != null) {
                if (equipe.contre.J1.numero == null) {
                    contre += "?";
                }
                else
                    contre += (equipe.contre.J1.numero+1);
              }
              if (equipe.contre.J2 != null)
                contre += " - " + (equipe.contre.J2.numero+1);
              if (equipe.contre.J3 != null)
                contre += " - " + (equipe.contre.J3.numero+1);
              return "SCORE : " + joueurs + " vs " + contre;
                }
                else
                    return "";
          },
          equipeWin() {
              this.equipe.score[this.type] = this.pointMax;
              this.$emit("changeType");
          },
          saveScore(score) {
              this.$emit("saveScore", score, this.scoreMax);
          }
    }
})
</script>

